import { createFileRoute } from "@tanstack/react-router";
import { DataPage } from "../../../../components/data/data-page";

export const Route = createFileRoute("/_authed/a/$slug/data")({
  component: DataRoute,
});

function DataRoute() {
  const { slug } = Route.useParams();
  return <DataPage key={slug} slug={slug} />;
}
